import { render } from "./AuditLogPDF.vue?vue&type=template&id=63dfd9b8&scoped=true"
import script from "./AuditLogPDF.vue?vue&type=script&lang=js"
export * from "./AuditLogPDF.vue?vue&type=script&lang=js"

import "./AuditLogPDF.vue?vue&type=style&index=0&id=63dfd9b8&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63dfd9b8"]])

export default __exports__